module.exports = __webpack_public_path__ + "static/media/otherservices1.1169747b.jpg";